import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { branding } from '../../../common/text';

declare const GAMING: boolean;

@Component({
  selector: 'not-found-page',
  styleUrls: ['./not-found-page.component.scss'],
  templateUrl: './not-found-page.component.pug'
})
export class NotFoundPage implements OnInit {
  public brand: string = branding[GAMING ? 'gaming' : 'pfm'];

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  public ngOnInit() {
    this.titleService.setTitle(`${this.brand} - 404`);
  }
}
